<script>
import BlacklistedPhonesEditor from "./BlacklistedPhonesEditor.vue"
import _ from "lodash";
import PlatformHelper from "../../helpers/platform";
export default {
    name: "BlacklistedPhonesBlock",
    computed: {
        PlatformHelper() {
            return PlatformHelper
        }
    },
    data: () => ({
        platforms: [],
    }),
    components: {BlacklistedPhonesEditor},
    mounted() {
        let self = this;
        this.$store.getters['auth/user'].allowed_platforms.forEach(function (platform) {
            self.platforms.push(platform);
        });
        this.platforms = _.sortBy(this.platforms, 'name');
    }
}
</script>

<template>

    <div>
        <el-collapse>
            <el-collapse-item :title="p.name" :name="p.id" v-for="p in platforms" :key="p.id">
                <BlacklistedPhonesEditor :platform_id="p.id"/>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<style scoped>

</style>